import { render, staticRenderFns } from "./CompanyClientsModal.vue?vue&type=template&id=7c4f7674"
import script from "./CompanyClientsModal.vue?vue&type=script&lang=js"
export * from "./CompanyClientsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports